module.exports = __webpack_public_path__ + "img/mastercard_visa_logo.93861fc6.png";